import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../Context/LanguageContext';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

import UserProfile from '../../Component/Normal/UserProfile';
import CenterFollowModal from '../../Model/Individual/MySettingModel/CenterFollowModal';

import DefaultLogoPath from '../../image/DefaultLogo.png';

export default function ProgramFollowBox(props) {
  const {
    follows,
    followers,
    onClickFollow
  } = props;

  const { t } = useLanguage();

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [followStoreIds, setFollowStoreIds] = useState([]);
  const [isFollow, setIsFollow] = useState(true);
  const [clickData, setClickData] = useState(undefined);
  const [isClickedFollowSearch, setIsClickedFollowSearch] = useState(false);

  // 팔로우 중인 업체 키 추출 //
  useEffect(() => {
    let storeIds = [];

    follows.map((data) => storeIds.push(data.storeId));

    setFollowStoreIds(storeIds);
  }, [follows])

  // 찾아보기 버튼 클릭시 //
  function onClickSearchButton() {
    setIsFollow(true);
    setIsClickedFollowSearch(true);
  }

  // 승인 신청 클릭시 //
  function onClickFollowButton(data) {
    onClickFollow(data, isFollow);
    setIsClickedFollowSearch(false);
  }

  // 신청된 박스 클릭시 //
  function onClickStoreBox(data, isFollow) {
    setClickData(data);
    setIsFollow(isFollow);
    setIsClickedFollowSearch(true);
  }

  return (
    <TopLevelWrapper>
      {
        isClickedFollowSearch && 
        <CenterFollowModal 
          isExercise={true} 
          isFollow={isFollow} 
          followStoreIds={followStoreIds}
          follows={follows}
          clickData={clickData} 
          setClickData={setClickData} 
          onClickFollow={onClickFollowButton} 
          close={() => setIsClickedFollowSearch(false)} />
      }
      <TitleWrapper>
        <TitleBox backgroundColor={theme.subKey}>
          <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.subBackground} hover='default'>{t('myStoreSetting.program.title')}</Text>
        </TitleBox>
      </TitleWrapper>
      <InfoView>
        <InnerInfoBox>
          <ProgramExplanationBox>
            <ExplanationWrapper>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='default'>{t('myStoreSetting.program.followTitle')}</Text>
              <FindButton onClick={onClickSearchButton}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.text} hover='pointer'>{t('myStoreSetting.search')}</Text>
              </FindButton>
            </ExplanationWrapper>
            <Text style={{ marginTop: '6px' }} fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.subText} hover='default'>{t('myStoreSetting.program.followDescription')}</Text>
          </ProgramExplanationBox>
          <FollowBox>
            {
              follows.length === 0 ?
                <NoneFollowBox>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.line} hover='default'>{t('myStoreSetting.noPartner')}</Text>
                </NoneFollowBox>
                :
                <FollowWrapper>
                  {
                    follows.map((data, index) => (
                      <StoreBox key={index} onClick={() => onClickStoreBox(data, true)}>
                        <StoreLogoBox approval={data.status}>
                          <UserProfile profile={data.storeLogo} defaultProfile={DefaultLogoPath} />
                        </StoreLogoBox>
                        {
                          !data.status &&
                          <ApprovalWaitWrapper>
                            <Text fontFamily='NotoSansKR-Black' fontSize={14} color={theme.text} hover='cursor'>{t('myStoreSetting.approvalWaiting')}</Text>
                          </ApprovalWaitWrapper>
                        }
                      </StoreBox>
                    ))
                  }
                </FollowWrapper>
            }
          </FollowBox>
        </InnerInfoBox>
        <DivisionLine />
        <InnerInfoBox>
          <ProgramExplanationBox>
            <ExplanationWrapper>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='default'>{t('myStoreSetting.program.followerTitle')}</Text>
            </ExplanationWrapper>
            <Text style={{ marginTop: '6px' }} fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.subText} hover='default'>{t('myStoreSetting.program.followerDescription')}</Text>
          </ProgramExplanationBox>
          <FollowBox>
            {
              followers.length === 0 ?
                <NoneFollowBox>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.line} hover='default'>{t('myStoreSetting.noFollower')}</Text>
                </NoneFollowBox>
                :
                <FollowWrapper>
                  {
                    followers.map((data, index) => (
                      <StoreBox key={index} onClick={() => onClickStoreBox(data, false)}>
                        <StoreLogoBox approval={data.status}>
                          <UserProfile profile={data.storeLogo} defaultProfile={DefaultLogoPath} />
                        </StoreLogoBox>
                        {
                          !data.status &&
                          <ApprovalWaitWrapper>
                            <Text fontFamily='NotoSansKR-Black' fontSize={14} color={theme.text} hover='cursor'>{t('myStoreSetting.approvalWaiting')}</Text>
                          </ApprovalWaitWrapper>
                        }
                      </StoreBox>
                    ))
                  }
                </FollowWrapper>
            }
          </FollowBox>
        </InnerInfoBox>
      </InfoView>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 30px;

  width: 100%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const TitleBox = styled.p`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 2px 20px;
  margin: 0 0 0 0;

  border-top-left-radius: 5px;
  border-top-right-radius: 5px;

  background-color: ${props => props.backgroundColor};
`;

const InfoView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 10px 20px;

  width: calc(100% - 40px);

  gap: 10px;

  border-radius: 0 10px 10px 10px;

  background-color: ${props => props.theme.subBackground};
`;

const InnerInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 546px;
  height: 312px;
`;

const DivisionLine = styled.div`
  width: 1px;
  height: 312px;

  background-color: ${props => props.theme.line};
`;

const ProgramExplanationBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding-bottom: 8px;
  margin-top: 10px;

  width: 100%;

  border-bottom: 1px solid ${props => props.theme.line};
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 29px;
`;

const FindButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 65px;
  height: 27px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 67px;
  background-color: ${props => props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const FollowBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 20px;

  width: 100%;
  height: 210px;

  overflow-x: hidden;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 0px;
  }

  &::-webkit-scrollbar-thumb {
    border: 3px solid transparent;
    background-color: ${props => props.theme.scrollBar};
    border-radius: 200px;
  }

  &::-webkit-scrollbar-track {
    background-color: ${props => props.theme.subBackground};
    border-radius: 200px;
  }
`;

const FollowWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  flex-wrap: wrap;

  gap: 10px;

  width: 100%;
`;

const NoneFollowBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
`;

const StoreBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 99px;
  height: 99px;

  border-radius: 15px;

  overflow: hidden;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const StoreLogoBox = styled.div`
  width: 100%;
  height: 100%;

  opacity: ${props => props.approval ? '1' : '0.6'};
`;

const ApprovalWaitWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 99px;
  height: 99px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  margin: 0 0 0 0;

  color: ${props => props.color};

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.hover};
    }
  }

  transition: all 0.3s ease-in-out;
`;